import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields} from "kea-react"
 

import { SucursalList } from "./list/list";
import { SucursalEdit } from "./edit/edit";

export class SucursalCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/Sucursal"  component={SucursalList} />
                <Route path="/catalogos/Sucursal/:id"  component={SucursalEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/index.tsx